/**
 * Een pauze tussen twee lesuren.
 *
 * Staat los van de lessen omdat pauzes geen appointments zijn: ze komen uit de
 * `breaks`-tabel in D1, niet uit Zermelo.
 *
 * Bewust een dunne regel en geen kaart: tussen de rijen van de lessen
 * moet een pauze een adempauze zijn, geen zesde blok. De stippellijn erachter vult
 * de breedte uit zonder gewicht toe te voegen.
 */
import type { Pauze } from '../types';
import { duurMinuten } from '../lib/tijd';

export function PauzeRegel({ pauze }: { pauze: Pauze }) {
  return (
    <div className="break-row">
      <span className="line" /><span aria-hidden="true">Ⅱ</span>
      <span className="label">{`${pauze.naam} · ${pauze.start} – ${pauze.end} · ${duurMinuten(pauze.start, pauze.end)} MIN`}</span>
      <span className="line" />
    </div>
  );
}
